import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=2867bc4e&scoped=true&"
import script from "./Insurance.vue?vue&type=script&lang=js&"
export * from "./Insurance.vue?vue&type=script&lang=js&"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=2867bc4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867bc4e",
  null
  
)

export default component.exports